<template>
  <div>
    <title-row
      title="Relék"
      :breadcrumb-items="[
        {
          text: 'Relék',
          disabled: true,
        },
      ]">
      <template #buttons>
        <title-row-button v-if="hasRight('DEVICE_WRITE')" :to="{ name: 'NewRelay' }">
          <v-icon left>mdi-plus</v-icon>
          Új relé
        </title-row-button>
      </template>
    </title-row>

    <v-expansion-panels
      class="mb-4 rounded-xl overflow-hidden"
      :mandatory="!!Object.values(search).find((e) => e !== '')"
      flat>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="font-weight-medium">
            <v-icon left>mdi-magnify</v-icon>
            Keresés
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="mt-2">
            <v-col :cols="12" :sm="4" :md="3">
              <v-text-field
                v-model="search.name"
                @input="searchEventHandler"
                label="Megnevezés"
                clearable
                hide-details
                filled />
            </v-col>
            <v-col :cols="12" :sm="4" :md="3">
              <v-autocomplete
                label="Kontroller"
                v-model="search.controller_id"
                @change="searchEventHandler"
                :items="controllers"
                item-text="name"
                item-value="element_id"
                hide-details
                clearable
                filled />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-card class="rounded-xl" flat>
      <v-data-table
        :loading="loading"
        :headers="dataTable.headers"
        :items="dataTable.items"
        :server-items-length="dataTable.itemsLength"
        :options.sync="dataTable.options"
        :footer-props="$config.dataTableFooterProps"
        calculate-widths>
        <template #[`item.actions`]="{ item }" class="d-flex justify-content-end" text-end>
          <v-btn
            v-if="hasRight('DEVICE_WRITE')"
            fab
            text
            small
            color="primary"
            dark
            elevation="0"
            class="rounded-sm"
            :to="{ name: 'RelayEditor', params: { id: item.element_id } }"
            title="Módosítás">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            v-if="hasRight('DEVICE_WRITE')"
            fab
            text
            small
            color="primary"
            dark
            elevation="0"
            class="rounded-sm"
            @click="deleteRelay(item)"
            title="Törlés">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import { dataTablePage } from '@/mixins';

export default {
  mixins: [dataTablePage],

  data() {
    return {
      routeName: 'RelayList',
      fetchItems: this.fetchRelays,
      dataTable: {
        options: {
          sortBy: ['name'],
        },
        headers: [
          { text: "Megnevezés", value: "name" },
          { text: "Kontroller", value: "controller" },
          { text: "Relé cím", value: "address" },
          { text: "", value: "actions", sortable: false, align: "end" },
        ],
      },
      search: {
        name: "",
        controller_id: null,
      },
      controllers: [],
    };
  },

  mounted() {
    this.fetchControllers();
  },

  methods: {
    parseSearchQueries() {
      return {
        name: this.$route.query.name,
        controller_id: Number(this.$route.query.controller_id),
      };
    },

    async deleteRelay(item) {
      const confirm = await this.$dialog.confirm({
        type: 'error',
        text: `<b>${item.name}</b> relé törlésére készül!<br>Folytatja?`,
        title: 'Figyelem',
      });

      if (!confirm) return;

      try {
        const response = await this.$http.get(`relays/delete/${item.element_id}`);
        this.fetchRelays();
        if (response.status === 'OK') {
          this.$dialog.notify.info('A relé törölve');
        }
      } catch (e) {
        console.error(e);
      }
    },

    async fetchControllers() {
      try {
        const response = await this.$http.post("controllers/list");
        this.controllers = response.controllers;
      } catch (e) {
        console.error(e);
      }
    },

    async fetchRelays() {
      this.loading = true;
      try {
        const response = await this.$http.post("relays/list", this.options);
        this.dataTable.items = response.relays;
        this.dataTable.itemsLength = response.relays_count;
        this.dataTable.options.page = this.$route.query.page * 1 || 1;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
  },

  computed: {
    searchQueries() {
      return {
        name: this.search.name || '',
        controller_id: this.search.controller_id || '',
      };
    }
  }
};
</script>
